import React from 'react';
import { Box } from 'rebass';
import classNames from 'classnames';

import helpersScreener from 'utils/helpers-screener';

import myxss from './myxss';

/**
 * Label component
 *
 * @param {Object} props
 * @param {Object} props.data
 * @param {boolean?} props.isPopup if true, then it's a popup
 */
const ComponentLabel = props => {
    const hasLabel = props.data.hasOwnProperty('label') && props.data.label;
    const hasImage = props.data.hasOwnProperty('label-image') ? props.data['label-image'] : false;
    let insert_html_sanitized = myxss.process(
        helpersScreener.insertPiping(props.data.label, props.all_questions, props.answers_by_form_element_name)
    );

    if (!hasLabel && !hasImage) {
        return null;
    }

    return (
        <Box
            mb={props.isPopup ? '4px' : 3}
            className={classNames('color-text-primary', props.isPopup ? 'fs-accent-14' : 'fs-title-16')}
        >
            {!props.data.static ? helpersScreener.showQuestionNumber(props.all_questions, props.data) : ''}
            <div
                style={{ whiteSpace: 'pre-wrap' }}
                className="quill-render"
                dangerouslySetInnerHTML={{ __html: insert_html_sanitized }}
            />
            {hasImage && <img src={hasImage} style={{ maxWidth: '100%', margin: '16px 0 0 0' }} />}
        </Box>
    );
};

export default ComponentLabel;
